var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.875V5.04804M2.79807 3.39945C2.54836 3.7069 2.34259 4.05071 2.189 4.4215C1.8415 5.26042 1.78054 6.19057 2.01556 7.06767C2.25058 7.94477 2.76845 8.71981 3.48886 9.27259C4.20927 9.82537 5.09195 10.125 6 10.125C6.90805 10.125 7.79073 9.82537 8.51114 9.27259C9.23155 8.71981 9.74942 7.94477 9.98444 7.06767C10.2195 6.19057 10.1585 5.26042 9.811 4.4215C9.65741 4.05071 9.45164 3.7069 9.20193 3.39945",
    stroke: "#D63333",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d97b10d8deb71e3fcdaf88ec971ea4ae.svg";
export { ForwardRef as ReactComponent };